import * as React from 'react'

export const useAiResponseStream = () => {
  const [aiResponse, setAiResponse] = React.useState('')
  const [targetJob, setTargetJob] = React.useState(null)
  const [aiStreamComplete, setAiStreamComplete] = React.useState(false)

  React.useEffect(() => {
    if (!targetJob) return

    const eventURL = `/job-search/jobs/${targetJob.id}/create_ai_sse?format=json`
    const eventSource = new EventSource(eventURL)

    eventSource.addEventListener('message', (event) => {
      if (event.data != 'null') {
        setAiResponse((r) => `${r}${event.data}`)
      }
    })

    eventSource.addEventListener('error', (event) => {
      if (event.eventPhase === EventSource.CLOSED) {
        eventSource.close()
      }
    })

    return () => {
      eventSource.close()
    }
  }, [targetJob])

  return {
    aiResponse,
    setAiResponse,
    targetJob,
    setTargetJob,
    aiStreamComplete,
    setAiStreamComplete,
  }
}
